import ToolTip from 'scenes/V2/ToolTip';
import Icon from './cred-icon.svg';

const RequiredCredential = props => {
  const { title, id, toolTipText } = props;
  return (
    <div className="required-credential gotham-medium-font" id={id}>
      <img src={Icon} alt={title} />
      {title}
      <ToolTip id={`${id}_icon`} bodyText={toolTipText} fontSize="17px" top="4px" />
    </div>
  );
};

export default RequiredCredential;
